import utils from 'utils'
import saleBillModal from './view/saleBillModal.html'
class workspaceItemCtrl {
    constructor($scope, logger, httpRequest, $state, $uibModal, $stateParams) {
        // 隐藏一二级菜单
        $('#wrapper').addClass('invoiceDetailPage')
        $scope.$on('$stateChangeStart', (event, toState) => {
            $('#wrapper').removeClass('invoiceDetailPage')
        })
        const item = JSON.parse(utils.decode($stateParams.taskId))
        const taskId = item.actionId
        $scope.currentSearchOtions = item.currentSearchOtions
        $scope.passBtnFlag = true
        if ($scope.currentSearchOtions && $scope.currentSearchOtions.taskType == 1) {
            $scope.passBtnFlag = false
        }
        $scope.item = $stateParams.pagedetail
        $scope.billList = []
        $scope.outdataList = []
        $scope.billflag = true // true: 看发票  false： 看销售单详情
        $scope.isRedBill = 0
        $scope.currentPage = 0
        $scope.totalInvoice = 0 // 当前任务发票总张数
        $scope.taskIdObj = {}// 当前页上一页下一页taskId
        // BEGIN：ADD by wxb for [添加数据初始化] on 1028-03-14
        const { userInfo } = $scope
        $scope.ukeyList = userInfo.sysUkeyList

        $scope.ivatTurnOutBackRedShow = false
        $scope.ivatTurnOutBackBlueShow = false
        if ($scope.currentSearchOtions) { // 如果从未处理审批单进来需显示上一条下一条功能
            $scope.currentSearchOtions.taskId = taskId
            // 获取上一条下一条id
            httpRequest.post_qryTaskDetailOfPage($scope.currentSearchOtions).then((res) => {
                $scope.taskIdObj = res.data.value
                if ($scope.taskIdObj.prevTaskId) $scope.showPreTask = true
                if ($scope.taskIdObj.nextTaskId) $scope.showNextTask = true
            })
        }

        // 上下条翻页
        $scope.changeTask = function (num) {
            if (num < 0) {
                if (!$scope.showPreTask) return
                item.actionId = $scope.taskIdObj.prevTaskId
                item.currentSearchOtions.destination = 'PREV'
            } else {
                if (!$scope.showNextTask) return
                item.actionId = $scope.taskIdObj.nextTaskId
                item.currentSearchOtions.destination = 'NEXT'
            }
            // console.log(item)
            $state.go('workspace.item', { taskId: utils.encode(JSON.stringify(item)) })
        }
        // 对外系统
        httpRequest.post_outSystemList().then((res) => {
            $scope.dictData.out_system = toOutSystemdata(res.data.value, 'busSysId', 'busSysName')
        })

        function toOutSystemdata (list, idfield, textfield) {
            const result = []
            for (const a in list) {
                const tempdata = { enumTypeCode: null, enumName: '', enumCode: '' }
                tempdata.enumCode = list[a][idfield]
                tempdata.enumName = list[a][textfield]
                result.push(tempdata)
            }
            return result
        }
        // END
        // add by wxb for [ 优化任务查询] on 2018-03-09 备注：$scope.item.data.invoice_type == '12' 为机动车发票校验
        httpRequest.get_getTaskById(taskId).then((res) => {
            $scope.item = res.data.value// 任务详情
            switch ($scope.item.approveCodeSimple) {
                case 'bill_approve':
                    $scope.billList = JSON.parse($scope.item.bussinessKey)// 把销售单业务主键处理
                    $scope.outdataList = JSON.parse($scope.item.outData)
                    $scope.currentPage = 0// 初始化销售单页码
                    $scope.billflag = true
                    $scope.totalInvoice = $scope.outdataList.length
                    const bussinessData = $scope.item.data
                    if (bussinessData.invoice_nature == '1' && bussinessData.invoice_type == '0') { // 红字信息表专票,会有多多张
                        $scope.isRedBill = 1
                    }
                    gobill($scope.billflag, $scope.item.data.invoice_type)
                    break
                case 'red_info_approve':// 红字信息表
                    $state.go('workspace.item.redinfo', { infoId: JSON.parse($scope.item.bussinessKey)[0] })
                    break
                case 'opened_invoice_approve':
                    if ($scope.item.data.invoice_type == '12') {
                        $state.go('workspace.item.vehicle', { waitId: JSON.parse($scope.item.bussinessKey)[0] })
                    } else if ($scope.item.data.invoice_type == '41') {
                        $state.go('workspace.item.roll', { waitId: JSON.parse($scope.item.bussinessKey)[0], code: $scope.item.approveCodeSimple })
                    } else {
                        $state.go('workspace.item.detail', { waitId: JSON.parse($scope.item.bussinessKey)[0] })
                    }
                    break
                case 'cancel_invoice_approve':
                case 'reopen_invoice_approve':
                    if ($scope.item.data.invoice_type == '12') {
                        $state.go('workspace.item.reopenVehicleApprove', { invoiceId: JSON.parse($scope.item.bussinessKey)[0] })
                    } else if ($scope.item.data.invoice_type == '41') {
                        $state.go('workspace.item.roll', { waitId: JSON.parse($scope.item.bussinessKey)[0], code: $scope.item.approveCodeSimple })
                    } else {
                        $state.go('workspace.item.opened', { invoiceId: JSON.parse($scope.item.bussinessKey)[0] })
                    }
                    break
                case 'ivat_turnout_approve':
                case 'ivat_turnback_approve':
                    if (JSON.parse($scope.item.bussinessKey)[0].slice(-1) === '1') { // 蓝票
                        httpRequest.get_qryTurnoutRecordByTurnoutId({ turnoutId: JSON.parse($scope.item.bussinessKey)[0] }).then((res) => {
                            $scope.ivatTurnOutBackBlueShow = true
                            $scope.turnTaxAmountBlue = res.data.value.turnTaxAmountFormat
                            $scope.turnRateBlue = res.data.value.turnRateFormat
                            $scope.turnDateBlue = res.data.value.turnDate
                            $scope.taxPeriodBlue = res.data.value.taxPeriod
                            $state.go('workspace.item.management', { object: JSON.stringify({ invoiceCode: res.data.value.invoiceCode, invoiceNumber: res.data.value.invoiceNumber }) })
                        })
                    }
                    if (JSON.parse($scope.item.bussinessKey)[0].slice(-1) === '2') { // 红票
                        $scope.ivatTurnOutBackRedShow = true
                        $state.go('workspace.item.redinfo', { infoId: JSON.parse($scope.item.bussinessKey)[0] })
                        httpRequest.get_getOvatRedInfoById({
                            infoId: JSON.parse($scope.item.bussinessKey)[0],
                        }).then((res) => {
                            $scope.infoCodeRed = res.data.value.infoCode
                        })
                    }
                    break
                case 'sb_approve':
                    const sbuuid = $scope.item.bussinessKey
                    httpRequest.get_getSbSbqkInfoBySbuuid(sbuuid.substring(2, sbuuid.length - 2)).then((res) => {
                        if (res.data.success) {
                            $scope.url = `${host.etcloudBiReport}ReportServer?reportlet=${res.data.value.mbkpz.path}&op=view&sbuuid=${res.data.value.sbuuid}`
                        }
                    })
                    break
                case 'ivat_expense_approve':// 报销单
                    $state.go('workspace.item.reiburseInfo', { expenseId: JSON.parse($scope.item.bussinessKey)[0] })
                    break
            }
        })
        // end

        // 跳转销售单详情
        function gobill (typ, invType) {
            if (typ) {
                let invoiceId = $scope.outdataList[$scope.currentPage]
                if ($scope.outdataList.length > 1) {
                    invoiceId = `${$scope.outdataList[$scope.currentPage]}options${JSON.stringify($scope.outdataList)}`
                }
                if ($scope.isRedBill == 1) {
                    $state.go('workspace.item.redinfo', { infoId: invoiceId })
                } else if (invType == 12) {
                    $state.go('workspace.item.vehicle', { waitId: $scope.outdataList[$scope.currentPage] })
                } else if (invType == 41) {
                    $state.go('workspace.item.roll', { waitId: invoiceId, code: $scope.item.approveCodeSimple })
                } else {
                    $state.go('workspace.item.detail', { waitId: invoiceId })
                }
            } else {
                $state.go('workspace.item.bill', { billId: $scope.billList[$scope.currentPage] })
            }
        }
        // 翻页按钮
        $scope.changepage = function (val) {
            $scope.currentPage += val
            $scope.currentPage = Math.max(0, $scope.currentPage)
            if ($scope.billflag) {
                $scope.currentPage = Math.min($scope.currentPage, $scope.outdataList.length - 1)
            } else {
                $scope.currentPage = Math.min($scope.currentPage, $scope.billList.length - 1)
            }
            gobill($scope.billflag, $scope.item.data.invoice_type)
        }
        // 关联销售单
        $scope.goRelatedBill = function (flag) {
            $uibModal.open({
                template: saleBillModal,
                controller: ['$scope', '$uibModalInstance', 'billList', 'logger', function ($scope, $uibModalInstance, billList, logger) {
                    $scope.billList = billList
                    $scope.currentBill = 0
                    $scope.showPreTask = false
                    $scope.showNextTask = false
                    if ($scope.billList.length > 1) {
                        $scope.showNextTask = true
                    }
                    $scope.cancel = function () {
                        $uibModalInstance.dismiss('cancel')
                    }
                    const dicArr = ['inv_type', 'invoice_nature', 'invoice_nature', 'bill_status', 'tax_includ', 'is_privilege', 'zero_tax', 'yes_no_flag', 'invoice_status', 'is_list']
                    $scope.currentPage1 = 1
                    $scope.maxSize1 = 5
                    $scope.currentPage2 = 1
                    $scope.maxSize3 = 5
                    $scope.billInfo = {}
                    $scope.qryBillDetail = {}
                    $scope.qryBillInvoice = {}

                    httpRequest.get_dictByTypeArr(dicArr).then((res) => {
                        $scope.dictData = res.data.value
                    })

                    $scope.getInfo = function (qryAPI, param) { //获取详情
                        httpRequest[qryAPI](param).then((res) => {
                            $scope.billInfo = res.data.value
                            if ($scope.billInfo.invoiceType == '41') {
                                httpRequest.post_getSysRollticketSpecList({
                                    pageNum: 1,
                                    pageSize: 10000,
                                    param: {},
                                }).then((response) => {
                                    if (response.data.success) {
                                        $scope.billInfo.rollticketCode = response.data.value.list.filter((item) => item.rollticketCode == JSON.parse($scope.billInfo.extendInfo).rollticketCode)[0].specification
                                    }
                                })
                            }
                        })
                    }

                    $scope.getInfo('get_qryBillInfo', $scope.billList[$scope.currentBill])

                    // 分页获取商品明细列表
                    const qryBillDetailList = function () {
                        const req = {
                            pageNum: $scope.currentPage1,
                            pageSize: $scope.maxSize1,
                            param: $scope.billList[$scope.currentBill],
                        }
                        httpRequest.post_qryBillDetailList(req).then((res) => {
                            $scope.qryBillDetail.list = res.data.value.list
                            $scope.totalItems1 = res.data.value.total
                            $scope.currentPage1 = ++res.data.value.prePage
                            $scope.maxSize1 = res.data.value.pageSize
                        })
                    }
                    // 分页获取发票详情列表 post_qryBillInvoice
                    const qryBillInvoice = function () {
                        const req = {
                            pageNum: $scope.currentPage2,
                            pageSize: $scope.maxSize2,
                            param: $scope.billList[$scope.currentBill],
                        }
                        httpRequest.post_qryBillInvoice(req).then((res) => {
                            $scope.qryBillInvoice.list = res.data.value.list
                            $scope.totalItems2 = res.data.value.total
                            $scope.currentPage2 = ++res.data.value.prePage
                            $scope.maxSize2 = res.data.value.pageSize
                        })
                    }
                    qryBillDetailList()
                    qryBillInvoice()
                    $scope.pageChanged1 = function () {
                        qryBillDetailList()
                    }

                    $scope.pageChanged2 = function () {
                        qryBillInvoice()
                    }

                    $scope.changeTask = function (n) {
                        if (n + $scope.currentBill < 0 || n + $scope.currentBill == $scope.billList.length) return
                        $scope.currentBill += n
                        $scope.currentPage1 = 1
                        $scope.currentPage2 = 1
                        if ($scope.currentBill == 0) {
                            $scope.showPreTask = false
                        } else {
                            $scope.showPreTask = true
                        }
                        if ($scope.currentBill == $scope.billList.length - 1) {
                            $scope.showNextTask = false
                        } else {
                            $scope.showNextTask = true
                        }
                        $scope.getInfo('get_qryBillInfo', $scope.billList[$scope.currentBill])
                        qryBillDetailList()
                        qryBillInvoice()
                    }
                }],
                backdrop: 'static',
                openedClass: 'mod-modal-haslist mod-modal mod-modal-lg modal-reimburse-invoice-detail collection-invoice-detail',
                resolve: {
                    billList () {
                        return $scope.billList
                    },
                },
            })
        }
        // 查找蓝票
        $scope.findBlue = function () {
            const keys = $scope.item.outData
            if (keys) {
                $state.go('workspace.item.opened', { invoiceId: JSON.parse(keys)[0] })
            } else {
                logger.logError('系统暂时无对应蓝票!')
            }
        }
        // 审核通过
        $scope.pass = function () {
            httpRequest.post_submitTask({
                isPass: 1,
                taskId: $scope.item.actionId,
            }, '处理成功').then((res) => {
                $scope.item.isPass = '1'
                if ($scope.taskIdObj.nextTaskId) {
                    item.actionId = $scope.taskIdObj.nextTaskId
                    item.currentSearchOtions.destination = 'NEXT'
                    $state.go('workspace.item', { taskId: utils.encode(JSON.stringify(item)) })
                } else if (!$scope.taskIdObj.prevTaskId) {
                    $state.go('workspace.list', { approveCode: $scope.item.approveCodeSimple })
                }
            })
        }
        // 审核不通过
        $scope.notpass = function () {
            logger.logMsg({
                title: '审核',
                icon: 'tishi',
                btn: ['确定', '取消'],
                message: '<p>确定审核不通过吗？<br>您可以写下不通过原因，帮助申请者改正!</p><textarea class="form-control" style="resize: none;font-size: 13px;"></textarea>',
                yes (index) {
                    const reason = $('.layui-layer-content textarea').val()
                    if (reason && reason.length > 100) {
                        logger.logError('提交失败审核原因不能超过100字符')
                        return
                    }
                    httpRequest.post_submitTask({
                        isPass: 0,
                        reason,
                        taskId: $scope.item.actionId,
                    }, '处理成功').then(() => {
                        $scope.item.isPass = '0'
                        if ($scope.taskIdObj.nextTaskId) {
                            item.actionId = $scope.taskIdObj.nextTaskId
                            item.currentSearchOtions.destination = 'NEXT'
                            $state.go('workspace.item', { taskId: utils.encode(JSON.stringify(item)) })
                        } else if (!$scope.taskIdObj.prevTaskId) {
                            $state.go('workspace.list', { approveCode: $scope.item.approveCodeSimple })
                        }
                    })
                    layer.close(index) // 如果设定了yes回调，需进行手工关闭
                },
            })
            // layer.open({
            //     title: '审核',
            //     icon: 'tishi',
            //     content: '<p>确定审核不通过吗？<br>您可以写下不通过原因，帮助申请者改正!</p><textarea style="width:100%;height:60px;"></textarea>',
            //     yes(index) {
            //         const reason = $('.layui-layer-content textarea').val()
            //         if (reason && reason.length > 100) {
            //             logger.logError('提交失败审核原因不能超过100字符')
            //             return
            //         }
            //         httpRequest.post_submitTask({
            //             isPass: 0,
            //             reason,
            //             taskId: $scope.item.actionId,
            //         }, '处理成功').then(() => {
            //             $scope.item.isPass = '0'
            //             if ($scope.taskIdObj.nextTaskId) {
            //                 item.actionId = $scope.taskIdObj.nextTaskId
            //                 item.currentSearchOtions.destination = 'NEXT'
            //                 $state.go('workspace.item', { taskId: utils.encode(JSON.stringify(item)) })
            //             } else if (!$scope.taskIdObj.prevTaskId) {
            //                 $state.go('workspace.list', { approveCode: $scope.item.approveCodeSimple })
            //             }
            //         })
            //         layer.close(index) // 如果设定了yes回调，需进行手工关闭
            //     },
            // })
        }
    }
}
workspaceItemCtrl.$inject = ['$scope', 'logger', 'httpRequest', '$state', '$uibModal', '$stateParams']
export default workspaceItemCtrl



// WEBPACK FOOTER //
// ./src/app/main/workspace/workspaceItemCtrl.js